import React from 'react';

const LegacyVaultPricingSkeleton: React.FC = () => {
    return (
        <section className="py-12 lg:py-16" id="legacy-vault-pricing">
            <div className="mx-auto max-w-[1142px] px-4">
                <div className="mx-auto pb-14 text-center lg:w-2/3 lg:pb-24">
                    <div className="mb-5 h-8 w-96 mx-auto bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div>
                    <div className="h-6 w-80 mx-auto bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div>
                </div>

                <div className="grid gap-8 lg:grid-cols-3">
                    {[1, 2, 3].map((index) => (
                        <div
                            key={index}
                            className="group relative flex h-full flex-col rounded-2xl border-2 border-green-200 bg-white dark:border-green-800 dark:bg-secondary p-8 transition-all duration-300"
                            data-aos="fade-up"
                            data-aos-duration="1000"
                            data-aos-delay={index * 200}
                        >
                            <div className="mb-6 text-center">
                                <div className="mb-4 flex justify-center">
                                    <div className="h-8 w-8 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div>
                                </div>
                                <div className="mb-2 h-8 w-48 mx-auto bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div>
                                <div className="mb-4 h-12 w-20 mx-auto bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div>
                                <div className="h-4 w-64 mx-auto bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div>
                            </div>

                            <ul className="mb-8 flex-grow space-y-3">
                                {[1, 2, 3, 4, 5].map((featureIndex) => (
                                    <li key={featureIndex} className="flex items-center gap-3">
                                        <div className="h-5 w-5 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div>
                                        <div className="h-4 w-48 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div>
                                    </li>
                                ))}
                            </ul>

                            <div className="mt-auto">
                                <div className="w-full h-12 bg-gray-200 dark:bg-gray-700 rounded-lg animate-pulse"></div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default LegacyVaultPricingSkeleton;
